import { call, put, takeEvery } from "redux-saga/effects"

import { GET_PERMISSIONS, ADD_NEW_PERMISSION, UPDATE_PERMISSION, DELETE_PERMISSION } from "./actionTypes";
import {
    getPermissionsSuccess,
    getPermissionsFail,
    addPermissionSuccess,
    addPermissionFail,
    updatePermissionSuccess,
    updatePermissionFail,
    deletePermissionSuccess,
    deletePermissionFail,
   
} from "./actions"

import {
    getPermissions,
    addNewPermission,
    updatePermission,
    deletePermission,
   
} from "helpers/permissions/permissions_backend_helper";
import { toast } from "react-toastify";

function* fetchPermissions() {
    try {
        const response = yield call(getPermissions)
        yield put(getPermissionsSuccess(response))
    } catch (error) {
        yield put(getPermissionsFail(error))
    }
}

function* onAddNewPermission({ payload: data }) {
    try {
        const response = yield call(addNewPermission, data)
        yield put(addPermissionSuccess(response))
        toast.success("PERMISSION  Added Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(addPermissionFail(error))
        toast.error("PERMISSION  Added Failed", { autoClose: 2000 });
    }
}

function* onUpdatePermission({ payload: data }) {
    try {
        const response = yield call(updatePermission, data)
        yield put(updatePermissionSuccess(response))
        toast.success("PERMISSION  Updated Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(updatePermissionFail(error))
        toast.error("PERMISSION  Updated Failed", { autoClose: 2000 });
    }
}

function* onDeletePermission({ payload: data }) {

    try {
        const response = yield call(deletePermission, data)
        yield put(deletePermissionSuccess(response))
        toast.success("PERMISSION  Deleted Successfully", { autoClose: 2000 });
    } catch (error) {
        yield put(deletePermissionFail(error))
        toast.error("PERMISSION  Deleted Failed", { autoClose: 2000 });
    }
}


function* permissionSaga() {
    yield takeEvery(GET_PERMISSIONS, fetchPermissions)
    yield takeEvery(ADD_NEW_PERMISSION, onAddNewPermission)
    yield takeEvery(UPDATE_PERMISSION, onUpdatePermission)
    yield takeEvery(DELETE_PERMISSION, onDeletePermission)
}

export default permissionSaga;